import { from as observableFrom, Observable } from 'rxjs';
import { Injectable, Injector } from '@angular/core';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { CommandBase, MultiselectCommand, FilteredCommand } from '../../../core/model/command';
import { Router } from '@angular/router';
import { ComponentMessageDispatcher } from '../../../core/service/component-message-dispather.service';
import { Location } from '@angular/common';
import { rentalObjectCommand, RentalObjectMultiselectCommand } from '../../command/rental-object.command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { CopyRoomsFormComponent } from '../../component/copy-rooms-form/copy-rooms-form.component';
import { RentalObjectFilteredCommand } from '../../command/rental-object-filtered.command';

@Injectable()
export class CopyRoomsCommandHandler implements ICommandHandler {
  constructor(
    private _location: Location,
    private _actionService: ActionWindowService,
    private _messageDispatcher: ComponentMessageDispatcher,
    private _injector: Injector
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof FilteredCommand) {
      return command.id === rentalObjectCommand.copyRooms && command.filterProvider && command.totalAffectedItemsControlValue > 0;
    }
    return false;
  }

  execute(command: CommandBase): Observable<void> {
    const cmd = <RentalObjectFilteredCommand>command;
    return this._actionService.open(CopyRoomsFormComponent, this._injector, null, {
      filter: cmd.filterProvider.filterState,
      includedIds: cmd.includedIds,
      excludedIds: cmd.excludedIds,
      affectedItemsCount: cmd.totalAffectedItemsControlValue,
    });
  }
}
